import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useToastContext } from "../../context/ToastContext";
import { useLoader } from "../../context/LoaderContext";
import { useSettingsContext } from "../../context/SettingsContext";
import LogoutPopupModal from "./LogoutPopupModal";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import { userService } from "../../services/UserService";

const Settings: React.FC = () => {
  const { activeSettingsTab, setActiveSettingsTab, setIsSettingsOpen } =
    useSettingsContext();
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  const navigate = useNavigate();

  const { showToast } = useToastContext();
  const { showLoader, hideLoader } = useLoader();
  const { logout } = useAuth();

  // Check for tab param (returning from OAuth)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get("tab");
    
    if (tab === "integrations") {
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
      // Switch to integrations tab
      setActiveSettingsTab("integrations");
    }
  }, [setActiveSettingsTab]);

  const handleCloseSettings = () => {
    setIsSettingsOpen(false);
  };

  const handleLogout = async () => {
    showLoader();
    try {
      await userService.logoutUser();
      logout();
      showToast("success", "Logout successful!");
      setTimeout(() => {
        navigate("/auth");
      }, 1000);
    } catch (error) {
      console.error("Logout failed:", error);
      showToast("error", "Failed to logout. Please try again.");
    } finally {
      hideLoader();
    }
  };

  return (
    <div
      className="
    flex w-full h-full fixed top-0 left-0 z-[30]
    bg-background-default dark:bg-background-dark
    overflow-hidden
  "
    >
      <LeftPanel
        activeTab={activeSettingsTab}
        onTabChange={setActiveSettingsTab}
        onLogoutClick={() => setIsLogoutPopupOpen(true)}
        onCloseSettings={handleCloseSettings}
      />
      <RightPanel activeTab={activeSettingsTab} />

      {isLogoutPopupOpen && (
        <LogoutPopupModal
          onConfirm={handleLogout}
          onCancel={() => setIsLogoutPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default Settings;
